<template>
	<div class="flex h-full min-h-screen bg-canvas">
		<AppSidebar :collapsed="collapsed" @close="collapsed = true" />

		<div class="flex min-w-0 flex-1 flex-col">
			<AppTopbar @toggle="collapsed = !collapsed" />

			<main class="flex-1 overflow-x-hidden px-6 py-6">
				<slot />
			</main>

			<footer
				class="flex items-center justify-between border-t border-slate-200 bg-white px-6 py-3 text-xs text-slate-400"
			>
				<span class="font-semibold text-slate-500">Trip Planner</span>
				<div class="flex items-center gap-4">
					<span>&copy; {{ year }} Trip Planner. All rights reserved.</span>
					<a href="#" class="hover:text-brand-600">Privacy Policy</a>
					<a href="#" class="hover:text-brand-600">Terms &amp; Conditions</a>
				</div>
			</footer>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref } from "vue";

import { api } from "../api";
import AppSidebar from "./AppSidebar.vue";
import AppTopbar from "./AppTopbar.vue";

const collapsed = ref(false);
const year = new Date().getFullYear();

onMounted(() => {
	api.companySettings().catch(() => {});
});
</script>
